import imagesLoaded from 'imagesloaded';

$(document)
	.imagesLoaded()
	.always(() => {
		$('body').addClass('page-loaded');
	});
